export interface Translations {
  // Header
  home: string
  aboutUs: string
  vision: string
  mission: string
  news: string
  career: string
  contact: string
  
  // Home page
  welcomeTitle: string
  welcomeSubtitle: string
  aboutTitle: string
  aboutDescription: string
  visionTitle: string
  visionDescription: string
  missionTitle: string
  missionDescription: string
  
  // About page
  aboutPageTitle: string
  aboutPageDescription: string
  
  // Vision page
  visionPageTitle: string
  visionPageDescription: string
  missionPageTitle: string
  missionPageDescription: string
  
  // News section
  newsTitle: string
  allNews: string
  latestNews: string
  readMore: string
  
  // Career form
  submitApplication: string
  candidateName: string
  applyFor: string
  apply: string
  gender: string
  male: string
  female: string
  other: string
  maritalStatus: string
  single: string
  married: string
  divorced: string
  widowed: string
  dateOfBirth: string
  mobileNo: string
  email: string
  qualification: string
  yourMessage: string
  address: string
  uploadResume: string
  candidateImage: string
  iAmNotRobot: string
  submitApplicationButton: string
  submitting: string
  
  // Footer
  allRightsReserved: string
  
  // Common
  selectOne: string
  required: string
}

export const translations: Record<string, Translations> = {
  en: {
    // Header
    home: "Home",
    aboutUs: "About Us",
    vision: "Vision",
    mission: "Mission", 
    news: "News",
    career: "Career",
    contact: "Contact",
    
    // Home page
    welcomeTitle: "Welcome to LOKBHARATI GROUP OF SCHOOLS & COLLEGES",
    welcomeSubtitle: "Excellence in Education",
    aboutTitle: "About Our Institution",
    aboutDescription: "We are committed to providing quality education and holistic development for our students.",
    visionTitle: "Our Vision",
    visionDescription: "To be a leading educational institution that nurtures young minds and prepares them for a bright future.",
    missionTitle: "Our Mission", 
    missionDescription: "To provide quality education that develops critical thinking, creativity, and character in our students.",
    
    // About page
    aboutPageTitle: "About Us",
    aboutPageDescription: "Learn more about our institution and our commitment to education.",
    
    // Vision page
    visionPageTitle: "Our Vision",
    visionPageDescription: "Our vision for the future of education and student development.",
    missionPageTitle: "Our Mission",
    missionPageDescription: "Our mission to provide the best education for our students.",
    
    // News section
    newsTitle: "Latest News & Activities",
    allNews: "All News",
    latestNews: "Latest News",
    readMore: "Read More",
    
    // Career form
    submitApplication: "Submit Application",
    candidateName: "Candidate Name",
    applyFor: "Apply For",
    apply: "Apply",
    gender: "Gender",
    male: "Male",
    female: "Female",
    other: "Other",
    maritalStatus: "Marital Status",
    single: "Single",
    married: "Married",
    divorced: "Divorced",
    widowed: "Widowed",
    dateOfBirth: "Date of Birth",
    mobileNo: "Mobile No",
    email: "Email",
    qualification: "Qualification",
    yourMessage: "Your Message",
    address: "Address",
    uploadResume: "Upload Resume",
    candidateImage: "Candidate Image",
    iAmNotRobot: "I am not a robot",
    submitApplicationButton: "Submit Application",
    submitting: "Submitting...",
    
    // Footer
    allRightsReserved: "All rights reserved.",
    
    // Common
    selectOne: "Select One",
    required: "*"
  },
  
  hi: {
    // Header
    home: "होम",
    aboutUs: "हमारे बारे में",
    vision: "दृष्टि",
    mission: "मिशन",
    news: "समाचार",
    career: "करियर",
    contact: "संपर्क",
    
    // Home page
    welcomeTitle: "LOKBHARATI GROUP OF SCHOOLS & COLLEGES में आपका स्वागत है",
    welcomeSubtitle: "शिक्षा में उत्कृष्टता",
    aboutTitle: "हमारे संस्थान के बारे में",
    aboutDescription: "हम अपने छात्रों के लिए गुणवत्तापूर्ण शिक्षा और समग्र विकास प्रदान करने के लिए प्रतिबद्ध हैं।",
    visionTitle: "हमारी दृष्टि",
    visionDescription: "एक अग्रणी शैक्षणिक संस्थान बनना जो युवा मन को पोषित करे और उन्हें उज्ज्वल भविष्य के लिए तैयार करे।",
    missionTitle: "हमारा मिशन",
    missionDescription: "गुणवत्तापूर्ण शिक्षा प्रदान करना जो हमारे छात्रों में आलोचनात्मक सोच, रचनात्मकता और चरित्र विकसित करे।",
    
    // About page
    aboutPageTitle: "हमारे बारे में",
    aboutPageDescription: "हमारे संस्थान और शिक्षा के प्रति हमारी प्रतिबद्धता के बारे में अधिक जानें।",
    
    // Vision page
    visionPageTitle: "हमारी दृष्टि",
    visionPageDescription: "शिक्षा और छात्र विकास के भविष्य के लिए हमारी दृष्टि।",
    missionPageTitle: "हमारा मिशन",
    missionPageDescription: "हमारे छात्रों के लिए सर्वोत्तम शिक्षा प्रदान करने का हमारा मिशन।",
    
    // News section
    newsTitle: "नवीनतम समाचार और गतिविधियां",
    allNews: "सभी समाचार",
    latestNews: "नवीनतम समाचार",
    readMore: "और पढ़ें",
    
    // Career form
    submitApplication: "आवेदन जमा करें",
    candidateName: "उम्मीदवार का नाम",
    applyFor: "के लिए आवेदन करें",
    apply: "आवेदन करें",
    gender: "लिंग",
    male: "पुरुष",
    female: "महिला",
    other: "अन्य",
    maritalStatus: "वैवाहिक स्थिति",
    single: "अविवाहित",
    married: "विवाहित",
    divorced: "तलाकशुदा",
    widowed: "विधवा",
    dateOfBirth: "जन्म तिथि",
    mobileNo: "मोबाइल नंबर",
    email: "ईमेल",
    qualification: "योग्यता",
    yourMessage: "आपका संदेश",
    address: "पता",
    uploadResume: "रिज्यूम अपलोड करें",
    candidateImage: "उम्मीदवार की छवि",
    iAmNotRobot: "मैं रोबोट नहीं हूं",
    submitApplicationButton: "आवेदन जमा करें",
    submitting: "जमा हो रहा है...",
    
    // Footer
    allRightsReserved: "सभी अधिकार सुरक्षित।",
    
    // Common
    selectOne: "एक चुनें",
    required: "*"
  },
  
  bn: {
    // Header
    home: "হোম",
    aboutUs: "আমাদের সম্পর্কে",
    vision: "দৃষ্টিভঙ্গি",
    mission: "মিশন",
    news: "খবর",
    career: "ক্যারিয়ার",
    contact: "যোগাযোগ",
    
    // Home page
    welcomeTitle: "LOKBHARATI GROUP OF SCHOOLS & COLLEGES-এ স্বাগতম",
    welcomeSubtitle: "শিক্ষায় উৎকর্ষতা",
    aboutTitle: "আমাদের প্রতিষ্ঠান সম্পর্কে",
    aboutDescription: "আমরা আমাদের শিক্ষার্থীদের জন্য মানসম্পন্ন শিক্ষা এবং সামগ্রিক বিকাশ প্রদানের জন্য প্রতিশ্রুতিবদ্ধ।",
    visionTitle: "আমাদের দৃষ্টিভঙ্গি",
    visionDescription: "একটি অগ্রণী শিক্ষা প্রতিষ্ঠান হওয়া যা তরুণ মনের বিকাশ ঘটায় এবং তাদের উজ্জ্বল ভবিষ্যতের জন্য প্রস্তুত করে।",
    missionTitle: "আমাদের মিশন",
    missionDescription: "মানসম্পন্ন শিক্ষা প্রদান করা যা আমাদের শিক্ষার্থীদের মধ্যে সমালোচনামূলক চিন্তাভাবনা, সৃজনশীলতা এবং চরিত্র গড়ে তোলে।",
    
    // About page
    aboutPageTitle: "আমাদের সম্পর্কে",
    aboutPageDescription: "আমাদের প্রতিষ্ঠান এবং শিক্ষার প্রতি আমাদের প্রতিশ্রুতি সম্পর্কে আরও জানুন।",
    
    // Vision page
    visionPageTitle: "আমাদের দৃষ্টিভঙ্গি",
    visionPageDescription: "শিক্ষা এবং শিক্ষার্থী উন্নয়নের ভবিষ্যতের জন্য আমাদের দৃষ্টিভঙ্গি।",
    missionPageTitle: "আমাদের মিশন",
    missionPageDescription: "আমাদের শিক্ষার্থীদের জন্য সেরা শিক্ষা প্রদানের আমাদের মিশন।",
    
    // News section
    newsTitle: "সর্বশেষ খবর ও কার্যক্রম",
    allNews: "সব খবর",
    latestNews: "সর্বশেষ খবর",
    readMore: "আরও পড়ুন",
    
    // Career form
    submitApplication: "আবেদন জমা দিন",
    candidateName: "প্রার্থীর নাম",
    applyFor: "যার জন্য আবেদন",
    apply: "আবেদন করুন",
    gender: "লিঙ্গ",
    male: "পুরুষ",
    female: "মহিলা",
    other: "অন্যান্য",
    maritalStatus: "বৈবাহিক অবস্থা",
    single: "অবিবাহিত",
    married: "বিবাহিত",
    divorced: "তালাকপ্রাপ্ত",
    widowed: "বিধবা",
    dateOfBirth: "জন্ম তারিখ",
    mobileNo: "মোবাইল নম্বর",
    email: "ইমেইল",
    qualification: "যোগ্যতা",
    yourMessage: "আপনার বার্তা",
    address: "ঠিকানা",
    uploadResume: "রিজিউমি আপলোড করুন",
    candidateImage: "প্রার্থীর ছবি",
    iAmNotRobot: "আমি রোবট নই",
    submitApplicationButton: "আবেদন জমা দিন",
    submitting: "জমা হচ্ছে...",
    
    // Footer
    allRightsReserved: "সকল অধিকার সংরক্ষিত।",
    
    // Common
    selectOne: "একটি নির্বাচন করুন",
    required: "*"
  }
}





